import hasPermission from './permissions'

const install = (Vue) => {
  Vue.directive('hasPermi', hasPermission)
}
export default install